export const shouldShowButton = (height: number, maxHeight: number): boolean =>
  height > maxHeight;
